module.exports = __webpack_public_path__ + "img/elec2.4f7abe6e.png";